module.exports = __webpack_public_path__ + "static/media/union.27878694.svg";